<ion-accordion-group #agroup [value]="expanded ? 'equipment' : ''" [class.expanded]="expanded" class="equipment-group">
  <ion-accordion value="equipment">
    <ion-item
      class="ion-no-padding"
      slot="header"
      id="equipment-settings-header"
      (click)="expanded ? $event.stopPropagation() : ''">
      <span class="icon-wrapper">
        <!-- OS Icon -->
        <ion-icon
          *ngIf="osIcon"
          class="ion-no-padding ion-no-margin"
          src="/assets/icons/24px/{{ osIcon }}"
          [tooltip]="
            (equipment$ | async)?.deviceInfo?.os_version
              ? (equipment$ | async)?.deviceInfo?.os + ' | ' + (equipment$ | async)?.deviceInfo?.os_version
              : (equipment$ | async)?.deviceInfo?.os
          "></ion-icon>

        <!-- Browser Icon -->
        <ion-icon
          *ngIf="browserIcon"
          class="ion-no-padding ion-no-margin"
          src="/assets/icons/24px/{{ browserIcon }}"
          [tooltip]="(equipment$ | async)?.deviceInfo?.browser"></ion-icon>

        <!-- Echo Cancellation Icon -->
        <ion-icon
          *ngIf="!isVoiceConf && (equipment$ | async)?.echoCancellation"
          class="ion-no-padding ion-no-margin"
          src="/assets/icons/24px/echo-cancellation.svg"
          tooltip="Echo Cancellation On"></ion-icon>

        <ion-icon
          class="ion-accordion-toggle-icon"
          [class.hidden]="expanded"
          src="/assets/icons/24px/chevron-down.svg"></ion-icon>
      </span>

      <span class="badge-wrapper">
        <ion-badge
          [class.disabled]="(equipment$ | async)?.mute"
          [tooltip]="
            filterDeviceName((equipment$ | async)?.audioIn?.label) +
            ' | ' +
            filterDeviceName((equipment$ | async)?.audioOut?.label)
          ">
          {{
            (equipment$ | async)?.mute
              ? 'Muted'
              : (equipment$ | async)?.sampleRate
              ? (equipment$ | async)?.sampleRate.toString().substring(0, 2) + ' kHz'
              : 'Microphone'
          }}
        </ion-badge>

        <ion-badge
          [class.disabled]="(equipment$ | async)?.videoOff"
          [tooltip]="filterDeviceName((equipment$ | async)?.videoIn?.label) ?? 'Camera Resolution'">
          {{ (equipment$ | async)?.videoOff ? 'Video Off' : displayResolution }}
        </ion-badge>

        <ion-badge
          *ngIf="(equipment$ | async)?.videoTrackSettings?.frameRate && !(equipment$ | async)?.videoOff"
          [tooltip]="filterDeviceName((equipment$ | async)?.videoIn?.label) ?? 'Camera Frames per Second'">
          {{ (equipment$ | async)?.videoTrackSettings.frameRate?.toFixed(0) }} fps
        </ion-badge>
      </span>
    </ion-item>
    <div class="ion-no-padding" slot="content" id="equipment-settings-body">
      <div *ngIf="agroup.value" class="list-item">
        <ion-icon src="/assets/icons/24px/microphone.svg"></ion-icon>
        <p
          *ngIf="
            (recording$ | async) ||
            (role$ | async) < roleLimits.SESSION_UPDATE ||
            !(equipment$ | async)?.availableDevices?.audioinput?.length
          "
          class="body-small">
          {{ filterDeviceName((equipment$ | async)?.audioIn?.label) ?? 'Unknown Microphone' }}
        </p>
        <ng-select
          *ngIf="
            (recording$ | async) !== true &&
            (role$ | async) >= roleLimits.SESSION_UPDATE &&
            (equipment$ | async)?.availableDevices?.audioinput?.length
          "
          [(ngModel)]="selectedAudioIn"
          class="small-select"
          [items]="(equipment$ | async)?.availableDevices.audioinput"
          bindLabel="label"
          bindValue="deviceId"
          (change)="selectAudioIn($event)"
          appendTo="body"
          [searchable]="false"
          [clearable]="false">
        </ng-select>
      </div>
      <div *ngIf="agroup.value" class="list-item">
        <ion-icon src="/assets/icons/24px/camera.svg"></ion-icon>
        <p
          *ngIf="
            (recording$ | async) ||
            (role$ | async) < roleLimits.SESSION_UPDATE ||
            !(equipment$ | async)?.availableDevices?.videoinput?.length
          "
          class="body-small">
          {{ filterDeviceName((equipment$ | async)?.videoIn?.label) ?? 'Unknown Camera' }}
        </p>
        <ng-select
          *ngIf="
            (recording$ | async) !== true &&
            (role$ | async) >= roleLimits.SESSION_UPDATE &&
            (equipment$ | async)?.availableDevices?.videoinput?.length
          "
          [(ngModel)]="selectedVideoIn"
          class="small-select"
          [items]="(equipment$ | async)?.availableDevices.videoinput"
          bindLabel="label"
          bindValue="deviceId"
          (change)="selectVideoIn($event)"
          appendTo="body"
          [searchable]="false"
          [clearable]="false">
        </ng-select>
        <ng-select
          *ngIf="
            (recording$ | async) !== true &&
            (role$ | async) >= roleLimits.SESSION_UPDATE &&
            (equipment$ | async)?.availableDevices?.videoinput?.length &&
            (studioSession$ | async)?.videoEnabled
          "
          [(ngModel)]="recordingResolution"
          class="small-select resolution-select"
          (change)="selectRecordingResolution($event)"
          appendTo="body"
          [searchable]="false"
          [clearable]="false">
          <ng-option
            *ngFor="let resolution of videoResolutions"
            [disabled]="!checkSupported(resolution)"
            [value]="resolution"
            >{{ getDisplayResolution(resolution) }}</ng-option
          >
        </ng-select>
      </div>
      <div *ngIf="agroup.value" class="list-item">
        <ion-icon src="/assets/icons/24px/sound.svg"></ion-icon>
        <p
          *ngIf="
            ((recording$ | async) ||
              (role$ | async) < roleLimits.SESSION_UPDATE ||
              !(equipment$ | async)?.availableDevices?.audiooutput?.length) &&
            (equipment$ | async)?.deviceInfo?.browser !== 'Firefox'
          "
          class="body-small">
          {{ filterDeviceName((equipment$ | async)?.audioOut?.label) ?? 'Unknown Speaker' }}
        </p>
        <p *ngIf="(equipment$ | async)?.deviceInfo?.browser === 'Firefox'" class="body-small">
          Firefox uses system default
        </p>
        <ng-select
        *ngIf="
          (recording$ | async) !== true &&
          (role$ | async) >= roleLimits.SESSION_UPDATE &&
          (equipment$ | async)?.availableDevices?.audiooutput?.length &&
          (equipment$ | async)?.deviceInfo?.browser !== 'Firefox'
        "
          [(ngModel)]="selectedAudioOut"
          class="small-select"
          [items]="(equipment$ | async)?.availableDevices.audiooutput"
          bindLabel="label"
          bindValue="deviceId"
          (change)="selectAudioOut($event)"
          appendTo="body"
          [searchable]="false"
          [clearable]="false">
        </ng-select>
      </div>
      <div
        class="list-item"
        *ngIf="!isVoiceConf && agroup.value && (role$ | async) >= roleLimits.PARTICIPANT_UPDATE"
        [tooltip]="sessionEchoCancellation ? 'Echo Cancellation is Controlled Globally for the Session' : ''">
        <ion-icon
          class="ion-no-padding ion-no-margin"
          [src]="
            (equipment$ | async)?.echoCancellation
              ? '/assets/icons/24px/echo-cancellation.svg'
              : '/assets/icons/24px/echo-cancellation-off.svg'
          "
          [tooltip]="
            (equipment$ | async)?.echoCancellation ? 'Echo Cancellation On' : 'Echo Cancellation Off'
          "></ion-icon>
        <p class="body-small">Echo Cancellation</p>
        <ion-toggle
          [checked]="(equipment$ | async)?.echoCancellation"
          [disabled]="(recording$ | async) || sessionEchoCancellation"
          mode="ios"
          slot="end"
          (ionChange)="echoCancellationToggled($event)"></ion-toggle>
      </div>
      <div class="list-item" *ngIf="agroup.value && (role$ | async) >= roleLimits.PARTICIPANT_UPDATE">
        <p class="body-small">Lossless Audio</p>
        <p *ngIf="equipment?.deviceInfo?.browser !== 'Chrome'" class="body-small">*Chromium Browsers Only</p>
        <ion-toggle
          [checked]="(equipment$ | async)?.pcmAudio"
          [disabled]="equipment?.deviceInfo?.browser !== 'Chrome'"
          mode="ios"
          slot="end"
          (ionChange)="pcmAudioToggled($event)"></ion-toggle>
      </div>
    </div>
  </ion-accordion>
</ion-accordion-group>
